import { requestSagas } from '@app/modules/requests/sagas';
/*
 * Root Saga
 */

import { authSagas } from "@app/modules/auth";
import { bootstrapSagas } from "@app/modules/bootstrap";
import { categorySagas } from "@app/modules/category-page";
import { brandSagas } from "@app/modules/brand";
import { dashboardSagas } from "@app/modules/dashboard";
import { salesPersonSagas } from "@app/modules/salesperson";
import { productsSagas } from "@app/modules/product";
import { myProfileSagas } from "@app/modules/my-profile";
import { modelSagas } from "@app/modules/model";

const rootSaga: any[] = [
  authSagas,
  // loginSagas,
  bootstrapSagas,
  categorySagas,
  bootstrapSagas,
  dashboardSagas,
  salesPersonSagas,
  brandSagas,
  modelSagas,
  requestSagas,
  productsSagas, 
  myProfileSagas
];

export { rootSaga };
